import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldStructure } from '../../../common/response/response';
import { FORM_FIELD_TYPE_ENUM } from '../../enums/form-enum';
import Utils from '../../../utils/utils';
import { ButtonConfigurationInterface } from '../top-panel/top-panel';
import { MatMomentDatetimeModule } from '@mat-datetimepicker/moment';

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrl: './filter.component.scss',
    providers: [MatMomentDatetimeModule],
})
export class FilterComponent {
    @Input() filterForm!: FormGroup;
    @Input() filterFieldsJson!: FieldStructure[];
    @Input() filterBtnConfiguration!: ButtonConfigurationInterface[];
    @Output() emitEvent = new EventEmitter<string>();
    fieldTypeEnum = FORM_FIELD_TYPE_ENUM;
    utils = Utils;

    handleFilterBtn(btnEmitEvent: string) {
        this.emitEvent.emit(btnEmitEvent);
    }
}
